import { removeCookie, read, write } from './utilities'

export function setConfiguration(configObject) {
  // The user overrides the default config
  mergeDeep(window.CConsentManager.config, configObject)

  window.CConsentManager._services =
    window.CConsentManager.config.categories.reduce(function (services, category) {
      if (Array.isArray(category.services)) {
        return services.concat(category.services)
      }
    }, [])

  // The cookie overrides the default and user config
  cookieToConfig();
}

function cookieToConfig() {
  function removeReload() {
    removeCookie();
    location.reload();
    return false;
  }

  const cookies = document.cookie ? document.cookie.split('; ') : []
  for (const cookie of cookies) {
    if (cookie.indexOf(CConsentManager.config.cookieName) >= 0) {
      var cookieData = JSON.parse(read(cookie.slice(cookie.indexOf('=') + 1)));

      // We check cookie version. If older we need to renew cookie.
      if (typeof cookieData.version === 'undefined') {
        return removeReload();
      } else {
        if (cookieData.version !== window.CConsentManager.config.cookieVersion) {
          return removeReload();
        }
      }

      const decoratedCategories = cookieData.categories.reduce((categories, category) => {
        return {
          ...categories,
          [category.name]: category.services.map((service) => service.name)
        }
      }, {})

      // We integrate cookie data into the global config object
      window.CConsentManager.config.categories.forEach((category) => {
        category.services.forEach((service) => {
          const status =
            service.mandatory ||
            (decoratedCategories[category.name] ?
              decoratedCategories[category.name].includes(service.name) :
              false)
          service.wanted = status
          service.checked = status
        })
      })

      window.CConsentManager.config.cookieExists = true;
      return true;
    }
  }

  return false;
}

// Simple object check.
function isObject(item) {
  return (item && typeof item === 'object' && !Array.isArray(item));
}

//Deep merge two objects.
function mergeDeep(target, ...sources) {
  if (!sources.length) return target;
  const source = sources.shift();

  if (isObject(target) && isObject(source)) {
    for (const key in source) {
      if (isObject(source[key])) {
        if (!target[key]) Object.assign(target, { [key]: {} });
        mergeDeep(target[key], source[key]);
      } else {
        Object.assign(target, { [key]: source[key] });
      }
    }
  }

  return mergeDeep(target, ...sources);
}

export function saveConfiguration() {
  const page = window.location.href
  const datestamp = new Date().toString()
  const version = window.CConsentManager.config.cookieVersion

  window.CConsentManager.config.categories.forEach((category) => {
    if (Array.isArray(category.services)) {
      category.services.forEach((service) => {
        service.wanted = service.checked
      })
    }
  })

  const categories = window.CConsentManager.config.categories
    .filter((category) => !category.mandatory)
    .map((category) => {
      const services = category.services
        .filter((service) => service.checked)
        .map((service) => ({
          name: service.name
        }))

      return {
        name: category.name,
        wanted: category.wanted,
        services,
      }
    })
    .filter((category) => Boolean(category.services.length))

  const config = {
    page,
    version,
    datestamp,
    categories
  }

  const encodedConfig = write(JSON.stringify(config))

  let expires = new Date(Date.now() + 365 * 864e5)
  expires = expires.toUTCString()

  try {
    document.cookie = `${window.CConsentManager.config.cookieName
      }=${encodedConfig}; expires=${expires}; path=/; domain=${window.CConsentManager.config.rootDomain};`

  } catch (e) {
    throw new Error('Falha ao tentar salvar as configurações de Cookie')
  }
}
